import React, { useEffect, useState } from "react";
import QualifyView from "./components/QualifyView";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import { addToGoogleDataLayer } from "../../../shared/const/utls.js";

const HarpQualify = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    try {
      addToGoogleDataLayer(
        "HARP-qualify-check",
        "HARP Application",
        i18n.language
      );
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  }, [i18n.language]);

  return isError ? <Error /> : <QualifyView setIsError={setIsError} />;
};

export default withTranslation("common")(HarpQualify);
